import { Cookie } from '@/mixin/local-cookie'
import { ApolloClient, HttpLink, InMemoryCache } from 'apollo-boost'
import { onError } from 'apollo-link-error'

// Handler for Error Unauthenticated
const errorHandler = onError(({ graphQLErrors }) => {
  graphQLErrors.forEach(function (item) {
    if (item.extensions && item.extensions.code == 'UNAUTHENTICATED') {
      localStorage.removeItem('token')

      window.location.href = '/login'
    }
  })
})

const pathName = window.location.pathname.split('/')
var authToken = localStorage.getItem('token')
if (authToken === null) authToken = Cookie.getLocalCookie().resource
if (pathName.includes('live-track')) {
  var param = window.location.search
  const urlParams = new URLSearchParams(param)

  const token = urlParams.get('token')
  authToken = token
}

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_API_URL,
  credentials: 'include',
  headers: {
    authorization: authToken ? `Bearer ${authToken}` : '',
  },
  errorHandler,
})

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorHandler.concat(httpLink),
  fetchPolicy: 'no-cache',
})
